<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        List VAT Out (PPN Keluaran)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="add()">Add</button>
          <button class="btn btn-primary mr-1" @click="printJv()">
            <i class="fa fa-print"></i> Print JV
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i> Export
          </button>
          <b-button variant="primary mr-1" @click="exportcsv()"
            >CSV e-Faktur</b-button
          >
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend
              ><span class="p-2">Periode Tanggal</span></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.tgl1"
              type="date"
              @change="updateTgl2"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text">s.d</span></b-input-group-prepend
            >
            <b-form-input v-model="filter.tgl2" type="date"></b-form-input>
            <b-input-group-append>
              <button class="btn btn-primary ml-1" @click="process()">
                <i class="fa fa-play"></i>Process
              </button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="4" class="text-right">
          <button class="btn btn-secondary mr-1" @click="isinofaktur()">
            Isi Otomatis No.Faktur yg Kosong
          </button>
        </b-col>
      </b-row>

      <b-card no-body v-if="filterShow == 'Hide'" class="mb-0">
        <template v-slot:header>
          <b-row class="mb-2">
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filterNonAp"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filterNonAp" @click="clearFilterNonAp"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOnNonAp" class="mt-1">
                  <b-form-checkbox value="namawp"
                    >Nama PKP penjual BKP/JKP</b-form-checkbox
                  >
                  <b-form-checkbox value="npwp">N P W P</b-form-checkbox>
                  <b-form-checkbox value="nofaktur">No Faktur</b-form-checkbox>
                  <b-form-checkbox value="invoice">No. Invoice</b-form-checkbox>
                  <b-form-checkbox value="uraian">Description</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
      </b-card>
      <b-table
        class="mb-0"
        ref="tableOri"
        sticky-header="600px"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="dataNonAp"
        :fields="tblNonAp.fields"
        :current-page="tblNonAp.page"
        :per-page="tblNonAp.limit"
        :sort-by.sync="tblNonAp.sortBy"
        :sort-desc.sync="tblNonAp.sortDesc"
        :filter="filterNonAp"
        :filterIncludedFields="filterOnNonAp"
        @filtered="onFilteredNonAp"
        @row-clicked="confirmAction"
        :tbody-tr-class="rowClass"
      >
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
          </div>
        </template>
        <template v-slot:cell(tglfaktur)="data">
          <span v-if="data.item.tglfaktur">{{
            data.item.tglfaktur | moment("DD-MMM-YYYY")
          }}</span>
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{ data.item.nilaippn | numFormat }}
        </template>
        <template v-slot:cell(ppnlcy)="data">
          {{ data.item.ppnlcy | numFormat }}
        </template>
        <template v-slot:cell(kursppn)="data">
          {{ data.item.kursppn | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(invdate)="data">
          <span v-if="data.item.invdate">{{
            data.item.invdate | moment("DD-MMM-YYYY")
          }}</span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div style="font-weight: bolder" :key="totalLcy">
            Total : {{ uanguser }} {{ totalLcy | numFormat }}
          </div>
        </b-col>
        <b-col cols="8">
          <b-row>
            <b-col cols="6" style="text-align: center">
              <div>
                Showing {{ (tblNonAp.page - 1) * tblNonAp.limit + 1 }} to
                <span v-if="tblNonAp.page * tblNonAp.limit > tblNonAp.total">{{
                  tblNonAp.total
                }}</span>
                <span v-else>{{ tblNonAp.page * tblNonAp.limit }}</span> of
                {{ tblNonAp.total }} entries,
                <span class="ml-3 mr-1">limit per page :</span>
                <select
                  v-model="tblNonAp.limit"
                  style="width: 60px"
                  class="ml-2"
                >
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                  <option>50</option>
                  <option>60</option>
                  <option>70</option>
                  <option>80</option>
                  <option>90</option>
                </select>
              </div>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b> {{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col cols="6">
              <b-pagination
                class="ml-1"
                align="right"
                :total-rows="tblNonAp.total"
                :per-page="tblNonAp.limit"
                v-model="tblNonAp.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showForm"
      header-bg-variant="primary"
      title="Edit - PPN Keluaran"
      size="lg"
      :centered="true"
      @ok="handleOk"
      ok-title="Save"
    >
      <b-form @submit.stop.prevent="save">
        <b-input-group>
          <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
          <b-form-input readonly v-model="model.customerinfo"></b-form-input>
          <b-input-group-append>
            <b-btn
              variant="primary"
              text="Button"
              @click="lkuCustomerShow = true"
            >
              <i class="fa fa-search"></i>
            </b-btn>
          </b-input-group-append>
        </b-input-group>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>N P W P</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.npwp"
                :state="!$v.model.npwp.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend class="d-md-inline d-lg-none"
                ><label class="text-right"
                  >&nbsp;-</label
                ></b-input-group-prepend
              >
              <b-form-radio-group class="mt-2" v-model="model.wpluarnegri">
                <b-form-radio :value="0">Lokal/Dlm Negeri</b-form-radio>
                <b-form-radio :value="1">Asing/Luar Negeri</b-form-radio>
              </b-form-radio-group>
            </b-input-group>
          </b-col>
        </b-row>

        <b-input-group>
          <b-input-group-prepend><label>Nama WP</label></b-input-group-prepend>
          <b-form-input
            v-model="model.namawp"
            :state="!$v.model.namawp.$error"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend
            ><label>Alamat WP</label></b-input-group-prepend
          >
          <b-form-input
            v-model="model.alamatwp"
            :state="!$v.model.alamatwp.$error"
          ></b-form-input>
        </b-input-group>
        <b-row v-if="model.wpluarnegri == 1">
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label>Kode Negara</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.wpkodenegri"
                :plain="true"
                :options="kodenegara"
              ></b-form-select>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Invoice Number</label></b-input-group-prepend
              >
              <b-form-input v-model="model.invoice"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label style="width: 100px"
                  >Invoice Date</label
                ></b-input-group-prepend
              >
              <b-form-input v-model="model.invdate" type="date"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai DPP</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{
                  model.matauang
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.nilaidpp"
                :precision="2"
                :state="!$v.model.nilaidpp.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai PPN</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{
                  model.matauang
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.nilaippn"
                :precision="2"
                :state="!$v.model.nilaippn.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Kurs Pajak</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{
                  model.matauang
                }}</span></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="pl-2 pt-2 pr-2">to</span></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text pl-3" style="width: 60px">{{
                  uanguser
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.kursppn"
                :precision="2"
                :state="!$v.model.kursppn.$error"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nilai PPN (LCY)</label></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 100px">{{
                  uanguser
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.ppnlcy"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>Kode Transaksi</label></b-input-group-prepend
              >
              <b-form-select
                v-model="model.kodetrx"
                :state="!$v.model.kodetrx.$error"
                :plain="true"
                :options="kodetransaksi"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label>Status Transaksi</label></b-input-group-prepend
              >
              <b-form-radio-group v-model="model.kodestatus" class="mt-2">
                <b-form-radio :value="0">0. Normal</b-form-radio>
                <b-form-radio :value="1">1. Penggantian</b-form-radio>
              </b-form-radio-group>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend
                ><label>No. Seri Faktur</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.nomorsfp"
                maxlength="17"
                v-b-tooltip.hover
                title="Jika dikosongkan, Sistem akan isi otomatis"
                placeholder="Kosongkan, u/ pengisian otomatis"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend
                ><label style="width: 100px"
                  >Tgl. Faktur</label
                ></b-input-group-prepend
              >
              <b-form-input
                v-model="model.tglfaktur"
                type="date"
                :state="!$v.model.tglfaktur.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import ppnkeluaran from "../../apis/ppnkeluaran";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import lkuCustomer from "../lookup/lkuCustomer";

toastr.init();

export default {
  components: { myNumber, Loading, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    filter: {
      tgl1: { required },
      tgl2: { required },
    },
    model: {
      namawp: { required },
      npwp: { required },
      alamatwp: { required },
      invoice: { required },
      invdate: { required },
      matauang: { required },
      //   nofaktur: { required },
      //   nomorsfp: { required },
      kodetrx: { required },
      tglfaktur: { required },
      nilaidpp: { required, minValue: minValue(1) },
      nilaippn: { required, minValue: minValue(1) },
      kursppn: { required, minValue: minValue(0.00000001) },
    },
  },
  data() {
    return {
      filter: { tgl1: "", tgl2: "" },
      isLoading: false,
      horizontal: true,
      showForm: false,
      lkuCustomerShow: false,
      reportUrl: null,
      showReport: false,
      tahun: moment(this.$store.state.user.tglaktif).format("YYYY"),
      uanguser: this.$store.state.user.matauang,
      model: {
        namawp: "",
        npwp: "",
        alamatwp: "",
        invoice: "",
        invdate: "",
        matauang: "",
        nofaktur: "",
        nomorsfp: "",
        kodetrx: "",
        tglfaktur2: "",
        nilaidpp: 0,
        kursppn: 1,
        nilaippn: 0,
        ppnlcy: 0,
        wpluarnegri: 0,
        wpluarnegri: 0,
      },
      selected: {},
      taxBussinesGroups: [],
      dataAp: [],
      dataNonAp: [],
      subtotal: {},
      tblNonAp: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "action",
            label: "",
            thStyle: "width:25px",
            thClass: "text-center",
          },
          {
            key: "namawp",
            label: "Nama PKP penjual BKP/JKP",
            sortable: true,
          },
          {
            key: "npwp",
            label: "N P W P",
            sortable: true,
          },
          {
            key: "nofaktur",
            label: "Nomor Faktur",
            sortable: true,
          },
          {
            key: "tglfaktur",
            label: "Tgl Faktur",
            sortable: true,
          },
          {
            key: "nilaippn",
            label: "Nilai PPN",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "createby",
            label: "input oleh",
            thStyle: "width:90px",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
          },
          {
            key: "invoice",
            label: "Nomor Invoice",
            sortable: true,
          },
          {
            key: "invdate",
            label: "Tgl Invoice",
            sortable: true,
          },
          {
            key: "matauang",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "ppnlcy",
            label: "Nilai Asli",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "kursppn",
            label: "Kurs",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nomor",
            label: "No. Jurnal",
            sortable: true,
          },
        ],
      },
      totalLcy: 0,
      filterShow: "Show",
      filterNonAp: null,
      filterOnNonAp: [],

      kodetransaksi: [
        {
          value: "01",
          text: "01.Penyerahan Barang Kena Pajak (BKP) atau Jasa Kena Pajak (JKP) yang PPNnya terutang dipungut oleh PKP penjual.",
        },
        {
          value: "02",
          text: "02.Penyerahan BKP atau JKP kepada pemungut PPN bendahara pemerintah yang PPNnya dipungut oleh bendahara pemerintah.",
        },
        {
          value: "03",
          text: "03.Penyerahan BPK/JKP kepada pemungut PPN lainnya yang PPNnya dipungut oleh pemungut PPN lainnya.",
        },
        {
          value: "04",
          text: "04.Penyerahan BPK/JKP yang menggunakan DPP nilai lain yang PPNnya dipungut oleh PKP penjual yang melakukan penyerahan.",
        },
        { value: "05", text: "05.Tidak digunakan" },
        {
          value: "06",
          text: "06.Penyerahan lain yang PPN-nya dipungut oleh PKP penjual yang melakukan penyerahan BPK/JKP, dan penyerahan kepada orang pribadi pemegang paspor luar negeri.",
        },
        {
          value: "07",
          text: "07.Penyerahan BKP/JKP yang mendapat fasilitas PPN Tidak Dipungut atau Ditanggung Pemerintah (DTP).",
        },
        {
          value: "08",
          text: "08.Penyerahan BKP/JKP yang mendapat fasilitas dibebaskan dari pengenaan PPN.",
        },
        {
          value: "09",
          text: "09.Penyerahan aktiva Pasal 16 D yang PPN-nya dpungut oleh PKP penjual.",
        },
      ],
      kodenegara: [
        { value: "AFG", text: "Afganistan" },
        { value: "AGO", text: "Angola" },
        { value: "ALB", text: "Albania" },
        { value: "AND", text: "Andorra" },
        { value: "ARE", text: "Uni Emirat Arab" },
        { value: "ARG", text: "Argentina" },
        { value: "ARM", text: "Armenia" },
        { value: "ATG", text: "Antigua dan Barbuda" },
        { value: "AUS", text: "Australia" },
        { value: "AUT", text: "Austria" },
        { value: "AZE", text: "Azerbaijan" },
        { value: "BDI", text: "Burundi" },
        { value: "BEL", text: "Belgia" },
        { value: "BEN", text: "Benin" },
        { value: "BFA", text: "Burkina Faso" },
        { value: "BGD", text: "Bangladesh" },
        { value: "BGR", text: "Bulgaria" },
        { value: "BHR", text: "Bahrain" },
        { value: "BHS", text: "Bahama" },
        { value: "BIH", text: "Bosnia dan Herzegovina" },
        { value: "BLR", text: "Belarus" },
        { value: "BLZ", text: "Belize" },
        { value: "BOL", text: "Bolivia" },
        { value: "BRA", text: "Brasil" },
        { value: "BRB", text: "Barbados" },
        { value: "BRN", text: "Brunei Darussalam" },
        { value: "BTN", text: "Bhutan" },
        { value: "BWA", text: "Bostwana" },
        { value: "CAF", text: "Afrika Tengah" },
        { value: "CAN", text: "Canada" },
        { value: "CHE", text: "Swiss" },
        { value: "CHL", text: "Chili" },
        { value: "CHN", text: "China" },
        { value: "CIV", text: "Pantai Gading" },
        { value: "CMR", text: "Kamerun" },
        { value: "COD", text: "Kongo - Republik Demokratik Kongo" },
        { value: "COG", text: "Kongo - Republik Kongo" },
        { value: "COL", text: "Kolombia" },
        { value: "COM", text: "Komoro" },
        { value: "CPV", text: "Tanjung Verde" },
        { value: "CRI", text: "Kosta Rika" },
        { value: "CUB", text: "Kuba" },
        { value: "CYP", text: "Siprus" },
        { value: "CZE", text: "Republik Ceko" },
        { value: "DEU", text: "Jerman" },
        { value: "DJI", text: "Djibouti" },
        { value: "DMA", text: "Dominika - Persemakmuran Dominika" },
        { value: "DNK", text: "Denmark" },
        { value: "DOM", text: "Dominika - Republik Dominika" },
        { value: "DSA", text: "Aljazair" },
        { value: "ECU", text: "Ekuador" },
        { value: "EGY", text: "Mesir" },
        { value: "ERI", text: "Eritrea" },
        { value: "ESP", text: "Spanyol" },
        { value: "EST", text: "Estonia" },
        { value: "ETH", text: "Ethiopia" },
        { value: "FIN", text: "Finlandia" },
        { value: "FJI", text: "Fiji" },
        { value: "FRA", text: "Perancis" },
        { value: "FSM", text: "Mikronesia" },
        { value: "GAB", text: "Gabon" },
        { value: "GBR", text: "Inggris" },
        { value: "GEO", text: "Georgia" },
        { value: "GHA", text: "Ghana" },
        { value: "GIN", text: "Guinea" },
        { value: "GMB", text: "Gambia" },
        { value: "GNB", text: "Guinea-Bissau" },
        { value: "GNQ", text: "Guinea Khatulistiwa" },
        { value: "GRC", text: "Yunani" },
        { value: "GRD", text: "Grenada" },
        { value: "GTM", text: "Guatemala" },
        { value: "GUY", text: "Guyana" },
        { value: "HKG", text: "Hong Kong" },
        { value: "HND", text: "Honduras" },
        { value: "HRV", text: "Kroasia" },
        { value: "HTI", text: "Haiti" },
        { value: "HUN", text: "Hungaria" },
        { value: "IND", text: "India" },
        { value: "IRL", text: "Irlandia" },
        { value: "IRN", text: "Iran" },
        { value: "IRQ", text: "Irak" },
        { value: "ISL", text: "Islandia" },
        { value: "ISR", text: "Israel" },
        { value: "ITA", text: "Italia" },
        { value: "JAM", text: "Jamaika" },
        { value: "JOR", text: "Yordania" },
        { value: "JPN", text: "Jepang" },
        { value: "KAZ", text: "Kazakhstan" },
        { value: "KEN", text: "Kenya" },
        { value: "KGZ", text: "Kirgiztan" },
        { value: "KHM", text: "Kamboja" },
        { value: "KIR", text: "Kiribati" },
        { value: "KNA", text: "Saint Kitts dan Nevis" },
        { value: "KOR", text: "Korea Selatan" },
        { value: "KWT", text: "Kuwait" },
        { value: "LAO", text: "Laos" },
        { value: "LBN", text: "Lebanon" },
        { value: "LBR", text: "Liberia" },
        { value: "LBY", text: "Libya" },
        { value: "LCA", text: "Saint Lucia" },
        { value: "LIE", text: "Liechtenstein" },
        { value: "LKA", text: "Sri Lanka" },
        { value: "LSO", text: "Lesotho" },
        { value: "LTU", text: "Lituania" },
        { value: "LUX", text: "Luxembourg" },
        { value: "LVA", text: "Latvia" },
        { value: "MAR", text: "Maroko" },
        { value: "MCO", text: "Monako" },
        { value: "MDA", text: "Moldova0" },
        { value: "MDG", text: "Madagaskar" },
        { value: "MDV", text: "Maladewa" },
        { value: "MEX", text: "Mexico" },
        { value: "MHL", text: "Marshall" },
        { value: "MKD", text: "Makedonia" },
        { value: "MLI", text: "Malia" },
        { value: "MLT", text: "Malta" },
        { value: "MMR", text: "Myanmar" },
        { value: "MNE", text: "Montenegro" },
        { value: "MNG", text: "Mongolia" },
        { value: "MOZ", text: "Mozambik" },
        { value: "MRT", text: "Mauritania" },
        { value: "MUS", text: "Mauritius" },
        { value: "MWI", text: "Malawi" },
        { value: "MYS", text: "Malaysia" },
        { value: "NAM", text: "Namibia" },
        { value: "NER", text: "Niger" },
        { value: "NGA", text: "Nigeria" },
        { value: "NIC", text: "Nikaragua" },
        { value: "NLD", text: "Belanda" },
        { value: "NOR", text: "Norwegia" },
        { value: "NPL", text: "Nepal" },
        { value: "NRU", text: "Nauru" },
        { value: "NZL", text: "Selandia Baru" },
        { value: "OMN", text: "Oman" },
        { value: "PAK", text: "Pakistan" },
        { value: "PAN", text: "Panama" },
        { value: "PER", text: "Peru" },
        { value: "PHL", text: "Philipina" },
        { value: "PLW", text: "Palau" },
        { value: "PNG", text: "Papua Nugini" },
        { value: "POL", text: "Polandia" },
        { value: "PRK", text: "Korea Utara" },
        { value: "PRT", text: "Portugal" },
        { value: "PRY", text: "Paraguay" },
        { value: "QAT", text: "Qatar" },
        { value: "ROU", text: "Romania" },
        { value: "RUS", text: "Rusia" },
        { value: "RWA", text: "Rwanda" },
        { value: "SAU", text: "Saudi Arabia" },
        { value: "SDN", text: "Sudan" },
        { value: "SEN", text: "Senegal" },
        { value: "SGP", text: "Singapura" },
        { value: "SLB", text: "Solomon" },
        { value: "SLE", text: "Sierra Leone" },
        { value: "SLV", text: "El Salvador" },
        { value: "SMR", text: "San Marino" },
        { value: "SOM", text: "Somalia" },
        { value: "SRB", text: "Serbia" },
        { value: "STP", text: "Sao Tome dan Principe" },
        { value: "SUR", text: "Suriname" },
        { value: "SVK", text: "Slovakia" },
        { value: "SVN", text: "Slovenia" },
        { value: "SWE", text: "Swedia" },
        { value: "SWZ", text: "Swaziland" },
        { value: "SYC", text: "Seychelles" },
        { value: "SYR", text: "Suriah" },
        { value: "TCD", text: "Chad" },
        { value: "TGO", text: "Togo" },
        { value: "THA", text: "Thailand" },
        { value: "TJK", text: "Tajikistan" },
        { value: "TKM", text: "Turkmenistan" },
        { value: "TLS", text: "Timor Leste" },
        { value: "TON", text: "Tonga" },
        { value: "TTO", text: "Trinidad dan Tobago" },
        { value: "TUN", text: "Tunisia" },
        { value: "TUR", text: "Turki" },
        { value: "TUV", text: "Tuvalu" },
        { value: "TWN", text: "Taiwan" },
        { value: "TZA", text: "Tanzania" },
        { value: "UGA", text: "Uganda" },
        { value: "UKR", text: "Ukraina" },
        { value: "URY", text: "Uruguay" },
        { value: "USA", text: "Amerika Serikat" },
        { value: "UZB", text: "Uzbekistan" },
        { value: "VAT", text: "Vatikan" },
        { value: "VCT", text: "Saint Vincent dan Grenadines" },
        { value: "VEN", text: "Venezuela" },
        { value: "VNM", text: "Vietnam" },
        { value: "VUT", text: "Vanuatu" },
        { value: "WSM", text: "Samoa" },
        { value: "YEM", text: "Yaman" },
        { value: "ZAF", text: "Afrika Selatan" },
        { value: "ZMB", text: "Zambia" },
        { value: "ZWE", text: "Zimbabwe" },
      ],
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    //   this.taxBussinesGroups= await ppnkeluaran.taxgroup();
    //  this.tahun=moment(user.tglaktif).format('YYYY');
    if (this.$route.params.tgl1 && this.$route.params.tgl2) {
      // this.filter.kodeaw = this.$route.params.kodeaw;
      // this.filter.kodeak = this.$route.params.kodeak || this.filter.kodeaw;
      // this.filter.kodeawinfo = this.$route.params.kodeaw;
      // this.filter.kodeakinfo = this.$route.params.kodeak || this.filter.kodeaw;
      this.filter.tgl1 = this.$route.params.tgl1;
      this.filter.tgl2 = this.$route.params.tgl2;
      this.process();
    } else {
      var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
        .add(1, "M")
        .subtract(1, "day");
      this.filter.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
      this.filter.tgl2 = tgl2.format("YYYY-MM-DD");
      this.tahun = tgl2.format("YYYY");
    }
  },
  methods: {
    rowClass(item) {
      if (!item.isSelected) return;
      if (item.isSelected) return "table-success";
    },
    // updateTgl1: function() {
    //     var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
    //     if (!this.filter.tgl1){
    //         this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
    //         this.tahun=tgl2.format('YYYY');
    //         this.$forceUpdate();
    //     } else {
    //         var tgl1 = moment(this.filter.tgl1, 'YYYY-MM-DD');
    //         if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
    //             this.filter.tgl1=`${tgl2.format('YYYY')}-01-01`;
    //             this.tahun=tgl2.format('YYYY');
    //             this.$forceUpdate();
    //         }
    //     }
    // },
    updateTgl2: function () {
      setTimeout(() => {
        var tgl1 = moment(this.filterHdr.tgl1, "YYYY-MM-DD");
        if (!this.filterHdr.tgl2) {
          this.filterHdr.tgl2 = `${tgl1.format("YYYY")}-12-31`;
          this.tahun = tgl1.format("YYYY");
          this.$forceUpdate();
        } else {
          var tgl2 = moment(this.filterHdr.tgl2, "YYYY-MM-DD");
          if (tgl1.format("YYYY") !== tgl2.format("YYYY")) {
            this.filterHdr.tgl2 = `${tgl1.format("YYYY")}-12-31`;
            this.tahun = tgl1.format("YYYY");
            this.$forceUpdate();
          }
        }
      }, 500);
    },
    onSelectLkuCustomer: async function (_selected) {
      this.model.customerinfo =
        _selected.CustName.trim() + " | " + _selected.CustCode.trim();
      // this.model.custcode = _selected.CustCode;
      this.model.customer_id = _selected.customer_id;
      this.model.namawp = _selected.npwp_name;
      this.model.npwp = _selected.npwp;
      this.model.alamatwp = _selected.npwp_address1;
      this.lkuCustomerShow = false;
    },
    onFilteredNonAp: function (filteredItems) {
      this.tblNonAp.total = filteredItems.length;
      this.tblNonAp.page = 1;
    },
    clearFilterNonAp() {
      this.filterOnNonAp = [];
      this.filterNonAp = "";
    },

    process: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
          const result = await ppnkeluaran.list(this.filter);
          this.dataNonAp = result[0];
          this.totalLcy = 0;
          this.dataNonAp.forEach((ap) => {
            this.totalLcy += ap.ppnlcy;
          });
          // console.log("totalLcy PPN: ", this.totalLcy);
          this.tblNonAp.total = result[0].length;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    edit: function (record) {
      if (this.row) delete this.row.isSelected;
      this.row = record;
      record.isSelected = 1;
      this.model = this.model || {};
      if (this.model.tablekey != record.tablekey) {
        this.model.tablekey = "";
        this.model.customer_id = "";
        this.model.customerinfo = "";
        this.model.namawp = "";
        this.model.npwp = "";
        this.model.alamatwp = "";
        this.model.invoice = "";
        this.model.invdate = "";
        this.model.matauang = "";
        this.model.nofaktur = "";
        this.model.nomorsfp = "";
        this.model.kodetrx = "";
        this.model.tglfaktur2 = "";
        this.model.nilaidpp = 0;
        this.model.kursppn = 1;
        this.model.nilaippn = 0;
        this.model.ppnlcy = 0;
        this.model.wpluarnegri = 0;

        for (var key in record) {
          this.model[key] = record[key];
        }
        this.model.invdate = record.invdate
          ? moment(record.invdate).format("YYYY-MM-DD")
          : "";
        this.model.tglfaktur = record.tglfaktur
          ? moment(record.tglfaktur).format("YYYY-MM-DD")
          : "";
        this.model.kodetrx = record.kodetrx || "01";
        this.model.kodestatus = record.kodestatus || 0;
        this.model.wpluarnegri = record.wpluarnegri || 0;
      }
      this.showForm = true;
    },
    confirmAction: function (record) {
      if (record.isSelected) {
        this.model = this.model || {};
        if (this.model.tablekey != record.tablekey) {
          this.model.tablekey = "";
          this.model.namawp = "";
          this.model.npwp = "";
          this.model.alamatwp = "";
          this.model.invoice = "";
          this.model.invdate = "";
          this.model.matauang = "";
          this.model.nofaktur = "";
          this.model.nomorsfp = "";
          this.model.kodetrx = "";
          this.model.tglfaktur2 = "";
          this.model.nilaidpp = 0;
          this.model.kursppn = 1;
          this.model.nilaippn = 0;
          this.model.ppnlcy = 0;
          this.model.wpluarnegri = 0;

          for (var key in record) {
            this.model[key] = record[key];
          }
          this.model.invdate = record.invdate
            ? moment(record.invdate).format("YYYY-MM-DD")
            : "";
          this.model.tglfaktur = record.tglfaktur
            ? moment(record.tglfaktur).format("YYYY-MM-DD")
            : "";
          this.model.kodetrx = record.kodetrx || "01";
          this.model.kodestatus = record.kodestatus || 0;
          this.model.wpluarnegri = record.wpluarnegri || 0;
        }
        this.showForm = true;
      } else {
        if (this.row) delete this.row.isSelected;
        this.row = record;
        record.isSelected = 1;
        this.$forceUpdate();
      }
    },
    handleOk: function (evt) {
      this.model.nofaktur = `${this.model.kodetrx}${
        this.model.kodestatus || "0"
      }${this.model.nomorsfp}`;
      evt.preventDefault();
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError == true)
              invalidobj[key] = this.$v.model[key];
          }
        }
        console.log("validation model: ", this.model);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else {
        this.save();
      }
    },

    isinofaktur: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
          const result = await ppnkeluaran.isinofaktur(this.filter);
          this.dataNonAp = result[0];
          this.tblNonAp.total = result[0].length;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          this.showReport = true;
          this.reportUrl = await ppnkeluaran.rptglprint(this.filter);
          this.isLoading = false;
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportcsv: async function () {
      if (this.invalidFilter) {
        console.log("selected obj : ", this.filter);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await ppnkeluaran.exportcsv(this.filter);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        console.log("selected obj : ", this.filter);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await ppnkeluaran.exportxls(this.filter);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    add: function () {
      toastr.info("Loading Form - Edit ");
      this.model.tablekey = "";
      this.model.namawp = "";
      this.model.npwp = "";
      this.model.alamatwp = "";
      this.model.invoice = "";
      this.model.invdate = "";
      this.model.matauang = "";
      this.model.nofaktur = "";
      this.model.nomorsfp = "";
      this.model.kodetrx = "";
      this.model.tglfaktur2 = "";
      this.model.nilaidpp = 0;
      this.model.kursppn = 1;
      this.model.nilaippn = 0;
      this.model.ppnlcy = 0;
      this.model.wpluarnegri = 0;

      this.showForm = true;
    },
    save: async function () {
      if (this.model.nomorsfp) {
        this.model.nofaktur = `${this.model.kodetrx || ""}${
          this.model.kodestatus || "0"
        }${this.model.nomorsfp}`;
      }
      if (this.invalidModel) {
        const invalidobj = {};
        for (var key in this.$v.model) {
          if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError == true)
              invalidobj[key] = this.$v.model[key];
          }
        }
        console.log("validation model: ", this.model);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else {
        this.isLoading = true;
        try {
          this.model.tglfaktur = moment(this.model.tglfaktur).format(
            "YYYY-MM-DD"
          );
          this.model.invdate = this.model.invdate
            ? moment(this.model.invdate).format("YYYY-MM-DD")
            : "";

          await ppnkeluaran.save(this.model);
          this.isLoading = false;
          for (var key in this.model) {
            this.row[key] = this.model[key];
          }
          this.row.tglfaktur = moment(this.model.tglfaktur, "YYYY-MM-DD");
          this.showForm = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },

    printJv: async function () {
      if (this.row) {
        this.isLoading = true;
        try {
          this.showReport = true;
          this.reportUrl = await ppnkeluaran.printjv(this.row);
          this.isLoading = false;
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Print!");
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
